'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _GenericTabs = require('./jsx/GenericTabs');

Object.defineProperty(exports, 'GenericTabs', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_GenericTabs).default;
  }
});

var _Tabs = require('./jsx/Tabs');

Object.defineProperty(exports, 'Tabs', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Tabs).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/generic-tabs/index.js
// module id = 680
// module chunks = 4